<template>
    <div class="p-[16px]">
        <div class="mb-[16px] flex items-center justify-between">
            <h2 class="text-[18px] text-[#2b2b2b] font-light">Mes Permissions</h2>
        </div>

        <div class="p-[6px] rounded-xl mb-[8px] bg-[#fff3ea] text-[#bf6d2e]">
            <p class="text-[12px] font-extralight">
                Veuillez appuyé sur le bouton "voir les détails" pour afficher le status
            </p>
        </div>

        <CustomTable :data="requests" :columnsCustom="columnn" :load="table_load">
            <template #other-filter>
                <div class="flex items-center gap-x-[8px]">
                    <button v-on:click="getData('refresh')" :disabled="table_load" class="size-[35px] border rounded-xl flex items-center justify-center">
                        <RefreshCw color="#2b2b2b" :size="16" strokeWidth="1.3" :class="{'animate-spin':actu_load}"/>
                    </button>
                    <div class="inline-block relative">
                        <button @click="show_advanced = !show_advanced" :class="['h-[35px] px-[12px] rounded-xl border flex items-center gap-x-[12px] font-light',{'bg-gray-100':show_advanced}]">
                            <SlidersHorizontal color="#2b2b2b" :size="16" strokeWidth="1.3"/>
                            Filtres
                        </button>
                        <Transition @before-enter="beforeEnterBox" @enter="enterBox" @leave="leaveBox">
                            <div v-if="show_advanced" id="advanced-filter" class="flex items-center gap-x-[12px] text-black font-light rounded-3xl p-6 shadow bg-white border absolute top-[120%] left-1/2 z-10">
                                <div class="flex items-center gap-x-[8px]">
                                    <label for="début" class="font-light">Début:</label>
                                    <input type="date" v-model="toSend.start" name="début" class="h-[35px] w-[130px] cursor-pointer p-3 rounded-xl border focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] placeholder:text-mutedForeground"/>
                                </div>
                                <div class="flex items-center gap-x-[8px]">
                                    <label for="fin" class="font-light">Fin:</label>
                                    <input type="date" v-model="toSend.end" name="début" class="h-[35px] p-3 w-[130px] cursor-pointer rounded-xl border focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] placeholder:text-mutedForeground"/>
                                </div>
                                <button v-on:click="getData" :disabled="table_load || actu_load" class="h-[35px] px-[12px] rounded-xl border flex items-center gap-x-[12px] font-light">
                                    Actualiser
                                </button>
                                <button @click="show_advanced = !show_advanced" class="size-[25px] rounded-full border flex items-center justify-center">
                                    <X :size="16" strokeWidth="1.3"/>
                                </button>
                            </div>
                        </Transition>
                    </div>

                    <button :class="['h-[35px] px-[12px] rounded-xl border flex items-center gap-x-[12px] font-light',{'bg-gray-100':filter_status == 'attente'}]" @click="selectFilter('0','attente')">
                        <FlagTriangleLeft :size="16" strokeWidth="1.3"/>
                        En attente
                    </button>
                </div>
            </template>
            <template #row-cell="slotProps">
                <span v-if="slotProps.cellNumber == 0" class="flex items-center gap-x-[8px]">
                    <span :class="['px-4 py-1 inline-flex items-center gap-x-[6px] rounded-xl',{'text-[#099556] bg-[#0995562e]':Number(slotProps.value.split('/')[1]) == 1,'text-[#fa9832] bg-[#fa993231]':Number(slotProps.value.split('/')[1]) == 0}]">
                        <div :class="['size-[8px] rounded-full',{'bg-[#099556]':Number(slotProps.value.split('/')[1]) == 1,'bg-[#fa9832]':Number(slotProps.value.split('/')[1]) == 0}]"/>
                        {{ slotProps.value.split('/')[0] }}
                    </span>
                </span>
                <span v-else-if="slotProps.cellNumber == 1">
                    <div class="flex items-center gap-x-[6px]">
                        <div class="size-[30px] rounded-full flex items-center justify-center bg-[#3474f4] text-white font-semibold">{{ slotProps.value.split('/')[0].trim()[0] }}</div>
                        <div class="flex flex-col items-start">
                            <span class="text-[12px]">{{ slotProps.value.split('/')[0] + " " + slotProps.value.split('/')[1] }}</span>
                            <span class="underline font-extralight text-[11px]">{{ slotProps.value.split('/')[2] }}</span>
                        </div>
                    </div>
                </span>
                <span v-else-if="slotProps.cellNumber == 2">
                    {{ formatDate(slotProps.value) }}
                </span>
                <span v-else-if="slotProps.cellNumber == 3">
                    <span class="px-4 py-1 rounded-xl">{{ formatDate2(slotProps.value) }}</span>
                </span>
                <span v-else-if="slotProps.cellNumber == 4" class="flex flex-wrap items-center justify-center">
                    <!-- <span class="px-3 py-1 rounded-lg bg-[#d7e6fe] text-[#1e265c]">Niveau 1</span>
                    <span class="px-3 py-1 rounded-lg bg-[#fcdfc0] text-[#442511]">Niveau 2</span>
                    <span class="px-3 py-1 rounded-lg bg-[#c7f3de] text-[#183726]">Niveau 3</span> -->
                    <!-- <button class="px-6 py-3 rounded-xl text-white bg-[#3c41e9]">Voir les détails</button> -->
                    <!-- <validationDetail :request="slotProps.value"/> -->
                    <!-- <span class="text-[12px] font-extralight px-3"> -->
                        <!-- @{{ slotProps.value.split('/')[0] }} -->
                    <!-- </span> -->
                </span>
                <!-- <span v-else-if="slotProps.cellNumber == 5">
                    <button class="size-[25px] rounded-xl border flex justify-center items-center">
                        <Ellipsis :size="16" strokeWidth="1.3"/>
                    </button>
                </span> -->
                <span v-else>{{ slotProps.value }}</span>
            </template>
            <template #bottom-popup>
                <!-- <Transition @before-enter="beforeEnterBar" @enter="enterBar" @leave="leaveBar">
                <div v-if="selectedRequests.length >= 1" class="fixed bottom-6 left-[30%] h-[45px] rounded-2xl min-w-[650px]
                     hover:shadow-xl text-slate-300 shadow-md
                    border-[1.58px] border-zinc-600 bg-zinc-950 flex items-center px-4 font-light">
                        <div class="grow"><p class="text-center"><span class="text-white">{{ selectedRequests.length }}</span> sur <span class="text-white">{{ requests.length }}</span> sélectionnées</p></div>
                        <button v-on:click="toggleAllSelection" class="text-[#ffffff] border-l border-l-zinc-600 h-full px-6 flex items-center">Tout sélectionnées</button>
                        <button class="text-[#ffffff] border-l border-l-zinc-600 h-full px-6 flex items-center gap-x-[12px]"><Check color="#ffffff" :size="16" strokeWidth="1.3"/> Valider</button>
                        <button class="text-[#ee4636] border-l border-l-zinc-600 h-full px-6 flex items-center gap-x-[12px]"><X color="#ee4636" :size="16" strokeWidth="1.3"/> Rejeter</button>
                </div>
                </Transition> -->
            </template>
        </CustomTable>
    </div>
</template>
<script>
import CustomTable from '@/components/tables/Custom-table.vue';
import API from '@/service/API';
import Swal from 'sweetalert2';
import {createColumnHelper} from "@tanstack/vue-table";
import { convertirDateEnFrancais, advancedFormat } from '@/utils/date-format';
import {SlidersHorizontal,RefreshCw,FlagTriangleLeft,X} from "lucide-vue-next";
import gsap from "gsap";

const columnHelper = createColumnHelper();
const columnsRequest = [
  columnHelper.accessor(row => `${row.motif.text}/${row.exception.is_perm}/${row.id}`, {
    id: 'désignation',
    header: 'Désignation',
    cell: info => info.getValue(),
  }),
  columnHelper.accessor(row => `${row.exception.user.first_name}/${row.exception.user.last_name}/${row.exception.user.email}`, {
    id: 'employé',
    header: 'Employé',
    cell: info => info.getValue(),
  }),
  columnHelper.accessor(row => row.created_at.split('T')[0], {
    id: 'Date requête',
    header: 'Date requête',
    cell: info => info.getValue(),
  }),
  columnHelper.accessor(row => `${row.exception.date_start}T${row.exception.date_end}`, {
    id: 'Date de debut/fin',
    header: 'Date de début/fin',
    cell: info => info.getValue(),
  }),
  columnHelper.accessor(row => row, {
    id: 'validation',
    header: 'Niveau de validation',
    cell: info => info.getValue(),
  })
];
export default {
    name: "UserPermission",
    components: {
        SlidersHorizontal,
        RefreshCw,
        CustomTable,
        // validationDetail,
        X,FlagTriangleLeft
    },
    data(){
        return {
            columnn: columnsRequest,
            table_load: false,
            actu_load: false,
            show_advanced: false,
            requests: [],
        }
    },
    mounted(){
        this.getAllUserException();
    },
    methods:{
        formatDate(date){return convertirDateEnFrancais(date)},
        formatDate2(date){
            const [date1,date2] = date.split('T');
            return advancedFormat(date1,date2);
        },
        getAllUserException(type = null){
            this.isload = true;
            if(type == 'refresh') this.actu_load = true;
            const date = new Date();
            const years = date.getFullYear();
            const month = (date.getMonth() + 1).toString().padStart(2,0);
            const day = date.getDate().toString().padStart(2,0);
            const id = localStorage.getItem("userId") ?? this.$store.getters.userId;
            const formData = new FormData();
            formData.append('date',this.date ? `${this.date.split("-")[0]}-${this.date.split("-")[1]}-01` : `${years}-${month}-${day}`);
            API.post("/getUserPermissions/"+id,formData)
            .then((res)=>{
                if(!res.data.status) throw Error(res.data.message);
            })
            .catch((error) => Swal.fire('Erreur!!!!',error?.message,'error'))
            .finally(()=>{
                this.isload = false;
                if(type == 'refresh') this.actu_load = false;
            })
        },
        beforeEnterBox(el){
            gsap.set(el, {
                xPercent: -50,
                scale: 0.97,
                y: -10,
                opacity: 0
            });
        },
        enterBox(el, done){
            gsap.to(el, {
                scale: 1,
                y: 0,
                opacity: 1,
                duration: 0.15,
                ease: "power2.out",
                onComplete: done,
            });
        },
        leaveBox(el, done){
            gsap.to(el, {
                scale: 0.95,
                y: -10,
                opacity: 0,
                duration: 0.15,
                ease: "power2.out",
                onComplete: done,
            });
        },
    }
}
</script>